import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios"; // Add axios for API calls
import logo from "../assets/logoweb.png";
import api from "../utils/api";
import { toast } from "react-toastify";
import { showCustomAlert } from "./User/Signup/Toast";

export default function ResetPass() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Extract 'token' from the query string
  const navigate = useNavigate();
  const [isModalVisible, setModalVisible] = useState(true); // Modal visibility state

  if (!token) {
    return <p>Invalid or missing token!</p>; // Handle invalid token case
  }

  // Password validation function
  const validatePassword = (password) => {
    // Password should contain at least one letter and one number
    const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/; // Min length 6
    return regex.test(password);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const newPassword = e.target.newPassword.value;
    const confirmPassword = e.target.confirmPassword.value;
    
    // Password match check
    if (newPassword !== confirmPassword) {
         showCustomAlert({
                title: 'Error!',
                html: '<p style="color: #555;">Password not matched		</p>',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#af313d',
                background: '#ffffff',
              });
            
      return;
    }

    // Password validation check
    if (!validatePassword(newPassword)) {
      showCustomAlert({
        title: 'Error!',
        html: '<p style="color: #555;">Password must be a combination of letters and numbers!</p>',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
      });
    
        
      return;
    }
  
    try {
      const apiUrl = `/auth/reset-password?token=${token}`; // Pass token in the query string
      const payload = { password: newPassword }; // Send only the new password
  
      console.log("🚀 ~ API Endpoint:", apiUrl);
      console.log("🚀 ~ API Payload:", payload);
  
      // API call
      const response = await api.post(apiUrl, payload);
  
      console.log("🚀 ~ API Response:", response);
      showCustomAlert({
        title: 'Password reset successfully!',
        html: '<p style="color: #555;">You can login to your account!</p>',
        icon: 'success',
        confirmButtonText: 'Continue',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
      });
    
      navigate("/"); // Redirect to homepage or login page
      setModalVisible(false); // Close modal on success
    } catch (error) {
      console.error("🚀 ~ API Error:", error);
      showCustomAlert({
        title: 'Error!',
        html: '<p style="color: #555;">An Error Accured		</p>',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
      });
    
    }
  };
  
  if (!isModalVisible) return null; // Hide modal when not visible

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-[90%] md:w-[80%] mx-auto lg:w-[50%] rounded-lg shadow-lg relative">
        <button
          onClick={() => setModalVisible(false)} // Close modal logic
          className="absolute top-3 right-6 bg-black rounded-full md:w-10 md:h-10 w-6 h-6 flex items-center justify-center text-xl text-white font-bold hover:text-gray-700"
        >
          <FiX />
        </button>

        <div className="p-8 max-h-[80vh] md:px-16 custom-scrollbar">
          <div className="flex items-center justify-center gap-2">
            <img
              src={logo}
              alt="Logo"
              className="lg:w-[66px] lg:h-[65px] md:w-[55px] md:h-[55px] w-[45px] h-[45px]"
            />
            <h1 className="lg:text-[20px] font-semibold text-[14.39px] sm:text-[14.39px]">
            Levante Cuisine
            </h1>
          </div>
          <h2 className="text-center font-baloo lg:text-[28px] font-[700] mb-4 mt-5">
            Reset Your Password
          </h2>
          <p className="text-center text-[10.07px] sm:text-[10.07px] md:text-[12px] lg:text-[13px] text-gray-500 mb-6">
            Please enter a new password to keep your account secure
          </p>
          <form onSubmit={handleResetPassword}>
            <div className="mb-4">
              <label
                htmlFor="newPassword"
                className="block text-[14px] font-medium text-black font-baloo mb-2"
              >
                Password
              </label>
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                placeholder="password"
                className="w-full p-3 border border-gray-300 rounded-md"
                required
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="confirmPassword"
                className="block text-[14px] font-medium text-black font-baloo mb-2"
              >
                Re-type Password
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                placeholder="confirm password"
                className="w-full p-3 border border-gray-300 rounded-md"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full rounded-full bg-[#AF313D] text-white p-3 mb-4 text-[14.39px] sm:text-[14.39px] lg:text-[20px] font-baloo font-semibold"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
